module.exports = __webpack_public_path__ + "img/payment-success.650c3a1e.svg";